import React from 'react';
import { Phone } from 'lucide-react';
import { FieldDisplayProps } from '../../types';

export const PhoneFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  return (
    <div
      className="phone-cell editable"
      onClick={handleClick}
      onDoubleClick={handleClick}
      title={value}
    >
      <Phone size={14} className="phone-icon" />
      <span className="phone-text">{value}</span>
    </div>
  );
};

export default PhoneFieldDisplay;
